import React, { useState, useEffect } from 'react'
import { Radio, Button, Typography } from 'antd'
import { db, timestamp } from '../../firebase'
import swal from 'sweetalert'
import { useDispatch, useSelector } from 'react-redux'
import { actions } from '../../redux'
import { Redirect } from 'react-router-dom'
import moment from 'moment'

const { Title } = Typography
const START_OF_VOTING = moment(new Date(2021, 3, 13))
const END_OF_VOTING = moment(new Date(2021, 4, 13))

function Voting() {
    const [value, setValue] = useState(null)
    const auth = useSelector(state => state.auth)
    const dispatch = useDispatch()
    const onChange = e => {
        setValue(e.target.value)
    }

    const submit = () => {

        const currentDate = moment(new Date())
        if(currentDate.isBefore(START_OF_VOTING)) return swal("Oops!", "Voting period starts on 12 April 2021.", "warning")
        if(currentDate.isAfter(END_OF_VOTING)) return swal('Oops!', "Voting period has ended.", "warning")
        return swal({
            icon: "info",
            title: "Summary of vote", 
            text: `1. ${value}`, 
            buttons: {
                cancel: "Back",
                confirm: {
                    text: "Submit",
                    value: "submit"
                }
            }
        }).then((val) => {
            if(val === "submit") {
                const vote = {
                    value,
                    timestamp: timestamp.fromDate(new Date()),
                    fullname: auth.fullname,
                    noOfShares: auth.noOfShares ?? null
                }
                const payload = { ...auth }
                payload.hasVoted = true

                dispatch(actions.signedIn(payload))
                db.collection('users').doc(auth.email).update({ "hasVoted": true })
                db.collection('votes').add(vote)

                swal("Thank you for casting your vote.", "The total votes casted, as well as the number of shares represented by the same, shall be announced during the 2021 Special Stockholders’ Meeting of Megawide Construction Corporation on 11 May 2021.", "success")
            }
        })
    }

    return (
        <div>
            {
                auth.isLoggedIn ? (
                    <div style={{maxWidth: '1000px', margin: 'auto'}}>
                        {
                            auth.hasVoted 
                                ? (<Title level={4}>Thank you for casting your vote. The total votes casted, as well as the number of shares represented by the same, shall be announced during the 2021 Special Stockholders’ Meeting of Megawide Construction Corporation on 11 May 2021.</Title>) 
                                : (
                                    <>
                                        <ol type="1">
                                            <li>
                                                Approval of the ammendment of Article Seventh of the Company's Article of Incorporation to increase its authorized capital stock by Twenty-Six Million Pesos (PhP 26,000,000.00), consisting twenty-six million (26,000,000) preferred shares, at One Peso (PhP 1.00) per share.
                                                <br /><br />
                                                <Radio.Group onChange={onChange} value={value}>
                                                    <Radio value="Yes">Yes</Radio>
                                                    <Radio value="No">No</Radio>
                                                    <Radio value="Abstain">Abstain</Radio>
                                                </Radio.Group>
                                            </li>
                                        </ol>
                                        <Button type='primary' onClick={() => submit()} disabled={value === null ? true : false}>Submit</Button>
                                    </>
                                )
                        }
                    </div>
                ) : (<Redirect to="/" />)
            }
        </div>
    )
}

export default Voting
